import { render, staticRenderFns } from "./SidePanelCard.vue?vue&type=template&id=4746666a&scoped=true&"
import script from "./SidePanelCard.vue?vue&type=script&lang=js&"
export * from "./SidePanelCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4746666a",
  null
  
)

export default component.exports